import React, { useState } from "react";
import { useSelector } from "react-redux";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { Button } from "react-bootstrap";
import { formatDate, permissionCssClass } from "../../../../util/Helpers";
import { Permissions, PermissionType } from "../../../../util/Permissions";
import { Card, CardBody } from "../../../../../_metronic/_partials/controls";
import TableSkeleton from "../../../../util/TableSkeleton";
import SimpleTable from "my-simple-react-table";
import { useGetExchangeRatesQuery } from "../../../../../redux/apiSlice";
import DeleteExchangeRateModal from "../modals/DeleteExchangeRateModal";
import EditExchangeRateModal from "../modals/EditExchangeRateModal";

const ViewExchangeRates = (
    {
        match: {
            params: { userGroup },
        },
    }
) => {
    const { PUBLIC_URL } = process.env;
    const adminUser = useSelector(state => state.auth.user);

    const { isFetching, data: exchangeRates } = useGetExchangeRatesQuery(userGroup)

    /* Exchange Rate Modal State Management */
    const [exchangeRateModal, setExchangeRateModal] = useState({
        showEditExchangeRateModal: false,
        showDeleteExchangeRateModal: false,
        details: null
    });

    /* Modal show/hide Toggle */
    const toggleModal = modal => _ => {
        setExchangeRateModal({ ...exchangeRateModal, [modal]: !exchangeRateModal[modal] })
    }

    /* Edit Exchange Rate Modal*/
    const editExchangeRate = details => {
        setExchangeRateModal({
            ...exchangeRateModal,
            showEditExchangeRateModal: true,
            details
        })
    }

    /* Delete Exchange Rate Modal */
    const deleteExchangeRate = (details) => {
        setExchangeRateModal({ ...exchangeRateModal, showDeleteExchangeRateModal: true, details });
    }

    const formatExchange = row => {
        return <div className="d-flex align-items-center" style={{ whiteSpace: "nowrap" }}>
            <div className="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">
                {row.fromCurrency}
                <span className="text-muted pl-2"> - {row.toCurrency}</span>
            </div>
        </div>
    }

    /* Action Buttons */
    const exchangeRateAction = (row) => {
        return (
            <span style={{ whiteSpace: "nowrap" }}>
                <Button
                    title="Edit Exchange Rate"
                    className={`btn btn-icon btn-light btn-hover-primary btn-sm mx-3 ${permissionCssClass(adminUser, Permissions.EXCHANGE_RATES, PermissionType.UPDATE)}`}
                    onClick={_ => editExchangeRate(row)}

                >
                    <span className="svg-icon svg-icon-md svg-icon-primary">
                        <SVG
                            title="Edit Exchange Rate"
                            src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
                        />
                    </span>
                </Button>

                <button
                    className={`btn btn-icon btn-white btn-hover-danger btn-sm ${permissionCssClass(adminUser, Permissions.EXCHANGE_RATES, PermissionType.DELETE)}`}
                    onClick={_ => deleteExchangeRate(row)}
                >
                    <span
                        className={`svg-icon svg-icon-md svg-icon-danger`}>
                        <SVG
                            title="Delete Exchange Rate"
                            src={toAbsoluteUrl("/media/svg/icons/Code/Error-circle.svg")}
                        />
                    </span>
                </button>
            </span>
        );
    };

    const formatRate = (row) => {
        return <div>
            {row.rate}
            <div className="text-muted">
                {
                    row.fromCurrency === "USD"
                        ? `${row.toCurrency} ${row.rate}`
                        : `${row.fromCurrency} ${1 / row.rate}`
                }
            </div>
        </div>
    }

    return (
        <>
            <Card>
                <CardBody>
                    {isFetching ? (
                        <TableSkeleton />
                    ) : (
                        <SimpleTable
                            key={userGroup}
                            data={exchangeRates?.data || []}
                            columns={[
                                { title: "EXCHANGE", format: formatExchange },
                                { title: "RATE", format: formatRate },
                                { title: "USER GROUP", key: "userGroup" },
                                { title: "UPDATED ON", format: (row) => formatDate(row.updatedAt) },
                                { title: "", format: exchangeRateAction },
                            ]}
                        />
                    )}
                </CardBody>
            </Card>

            <EditExchangeRateModal
                {...exchangeRateModal}
                onHide={toggleModal("showEditExchangeRateModal")}
            />
            <DeleteExchangeRateModal
                {...exchangeRateModal}
                onHide={toggleModal("showDeleteExchangeRateModal")}
                details={exchangeRateModal.details}
            />

        </>
    );
};

export default ViewExchangeRates;